import { render, staticRenderFns } from "./vedge.vue?vue&type=template&id=6828ddf9&scoped=true&"
import script from "./vedge.vue?vue&type=script&lang=ts&"
export * from "./vedge.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6828ddf9",
  null
  
)

export default component.exports